<template>
  <table
    class="color-manager uk-margin-remove-top uk-table uk-table-divider uk-table-justify"
  >
    <thead>
      <th>{{$t('fields.name')}}</th>
      <th>{{$t('fields.code')}}</th>
      <th>{{$t('fields.slug')}}</th>
      <th class="uk-table-shrink"></th>
    </thead>
    <tbody>
      <tr :key="color.code" v-for="(color, index) in colors">
        <td>
          <text-input
            :errors="errorsFor(index, 'name')"
            @blur="removeColorWhenEmpty(index)"
            @input="onInput"
            ref="colorName"
            v-model="color.name"
          />
        </td>
        <td>
          <color-code-input
            :errors="errorsFor(index, 'code')"
            @blur="removeColorWhenEmpty(index)"
            @input="onInput"
            ref="colorCode"
            v-model="color.code"
          />
        </td>
        <td>
          <text-input
            :errors="errorsFor(index, 'slug')"
            @blur="removeColorWhenEmpty(index)"
            @input="onInput"
            ref="colorSlug"
            v-model="color.slug"
          />
        </td>
        <td class="uk-table-shrink">
          <common-button
            @click="maybeRemoveColor(index)"
            icon="trash"
            tabindex="-1"
          />
        </td>
      </tr>
      <tr>
        <td>
          <text-input
            @input="addEntryWithName"
            ref="newColorName"
            v-model="newEntry.name"
          />
        </td>
        <td>
          <color-code-input @input="addEntryWithCode" v-model="newEntry.code" />
        </td>
        <td>
          <text-input @input="addEntryWithSlug" v-model="newEntry.slug" />
        </td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import UIkit from 'uikit';
import ColorCodeInput from './ColorCodeInput';
import ColorPreview from './ColorPreview';
import CommonButton from './CommonButton';
import TextInput from './TextInput';

function getColors(origColors) {
  return origColors.map(origColor => ({
    name: origColor.name,
    code: origColor.code,
    slug: origColor.slug,
  }));
}

export default {
  name: 'color-manager',
  components: {
    ColorCodeInput,
    ColorPreview,
    CommonButton,
    TextInput,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colors: getColors(this.value),
      newEntry: {
        name: null,
        code: null,
        slug: null,
      },
    };
  },
  watch: {
    value(value) {
      this.colors = getColors(value);
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.colors);
      this.$emit('change', this.colors);
    },
    errorsFor(index, key) {
      const messages = this.errors[index];
      if (!messages) return [];
      return messages[key] || [];
    },
    maybeRemoveColor(index) {
      UIkit.modal
           .confirm(this.$t('confirmations.remove'))
           .then(() => { this.removeColor(index); })
           .catch(() => {});
    },
    removeColor(index) {
      this.$delete(this.colors, index);
      this.onInput();
    },
    async removeColorWhenEmpty(index) {
      const entry = this.colors[index];

      if (entry && !entry.name && !entry.code) {
        this.removeColor(index);
        await this.$nextTick();
        this.$refs.newColorName.focus();
      }
    },
    addEntryWithName(name) {
      this.colors.push({ name, code: null, slug: null });
      return this.focusLastEntry('colorName');
    },
    addEntryWithCode(code) {
      this.colors.push({ name: null, code, slug: null });
      return this.focusLastEntry('colorCode');
    },
    addEntryWithSlug(slug) {
      this.colors.push({ name: null, code: null, slug });
      return this.focusLastEntry('colorSlug');
    },
    async focusLastEntry(key) {
      await this.$nextTick();
      const lastIndex = this.colors.length - 1;
      this.$refs[key][lastIndex].focus();
      this.newEntry.name = null;
      this.newEntry.code = null;
      this.newEntry.slug = null;
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          remove: 'Möchtest du die Farbe wirklich entfernen?',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ColorManager.vue?2eba6d93